import { render, staticRenderFns } from "./TokenDetail.vue?vue&type=template&id=49129afd&scoped=true"
import script from "./TokenDetail.vue?vue&type=script&lang=js"
export * from "./TokenDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49129afd",
  null
  
)

export default component.exports